import { render } from "./GameResult.vue?vue&type=template&id=3efcfb08"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"

import "./GameResult.vue?vue&type=style&index=0&id=3efcfb08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__